import clx from "classnames";
import AppIcon from "./AppIcon";

export default function Spinner({ loading = true, className = "w-4 h-4 text-muted-fg" }) {
  return loading ? <AppIcon code="fa-spinner" className={clx(className, "animate-spin")} /> : <></>;
}
